export default __webpack_public_path__ + "media/images/preview-679f7487fd7f303ee6cfccc3a221940c.png";